import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select-async-paginate';
import classNames from 'classnames';
import withValidation from '../../shared/withValidation'
import styles from './styles.scss';
import 'react-select/dist/react-select.css';


const PAGE_SIZE = 20;

class AsyncDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      page: 0,
      search: ''
    };
    this.select = React.createRef();
    this.onChange = this.onChange.bind(this);
    this.onLoad = this.onLoad.bind(this);
  }

  static get propTypes() {
    return {
      onChange: PropTypes.func,
      fetchOptions: PropTypes.func,
      getLabel: PropTypes.func,
      invalid: PropTypes.bool,
      error: PropTypes.string,
      placeholder: PropTypes.string,
      value: PropTypes.string
    }
  }

  static get defaultProps() {
    return {
      invalid: false,
      getLabel: option => option.name
    }
  }

  componentDidMount() {
    this.select.current.loadOptions();
  }

  onChange(value) {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  async onLoad(search) {
    const {
      fetchOptions,
      getLabel,
    } = this.props;
    const page = search === this.state.search ? this.state.page + 1 : 1;
    this.setState({ search });

    const response = await fetchOptions(page, PAGE_SIZE, search);
    this.setState({
      page: response.page
    });

    return {
      options: response.data.map(option => ({
        value: option.id,
        label: getLabel(option)
      })),
      hasMore: response.page < response.pageCount,
    };
  }

  render() {
    const {
      value,
      invalid,
      error,
      placeholder
    } = this.props;
    return [
      <AsyncSelect
        key='select'
        className={classNames(styles.dropdown, {
          [styles.invalid]: invalid
        })}
        clearable={false}
        multi={false}
        placeholder={placeholder}
        value={value}
        onChange={this.onChange}
        loadOptions={this.onLoad}
        valueKey='value'
        labelKey='label'
        ref={this.select}
      />,
      <If condition={invalid} key='error'>
        <span className={styles.error}>{error}</span>
      </If>
    ];
  }
}

export default withValidation(AsyncDropdown);



// WEBPACK FOOTER //
// src/components/shared/AsyncDropdown/index.jsx